import { Col } from 'antd';
import { LoginForm } from 'features/auth/components';

import { StyledBackground, StyledCard, StyledRow } from './login.styles';

export const LoginView = () => {
  return (
    <StyledBackground>
      <Col
        xs={24}
        sm={18}
        md={12}
        lg={12}
        xl={10}
        xxl={6}
        className='flex flex-col justify-center'
      >
        <Col xs={24} className='flex justify-center mb-10'>
          <img src='/partnerplus_logo.png' alt='login background' />
        </Col>

        <StyledCard>
          <StyledRow justify='center'>
            <Col
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <label className='mt-0 mb-3 text-center text-2xl font-bold text-blue-950'>
                Sign in to your account
              </label>
              {/* <label className='mt-0 mb-5 text-center text-md font-medium tracking-tight text-gray-900'>Partner Plus Customer Portal</label> */}
            </Col>
          </StyledRow>

          <StyledRow justify='center'>
            <Col xs={24}>
              <LoginForm />
            </Col>
          </StyledRow>
        </StyledCard>
      </Col>
    </StyledBackground>
  );
};
